import { apiClient } from './client';

/**
 * Client for `/api/compliance/auditor-seats`. Mirror the route shapes in
 * `server/src/routes/compliance/auditorSeats.routes.ts` exactly — keep
 * them in lockstep.
 */

export interface AuditorSeat {
  id: string;
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
  role: 'auditor_readonly';
  expiresAt: string | null;
  createdAt: string;
  status: 'active' | 'expired';
  invitedByMembershipId: string | null;
}

export async function listAuditorSeats(): Promise<AuditorSeat[]> {
  const res = await apiClient.get<{ data: AuditorSeat[] }>('/api/compliance/auditor-seats');
  return res.data.data;
}

export interface CreateAuditorSeatRequest {
  email: string;
  /** ISO datetime or YYYY-MM-DD. */
  expiresAt: string;
  /** Default true. Set false to skip Stytch send (useful in mock mode). */
  sendMagicLink?: boolean;
}

export interface CreateAuditorSeatResponse {
  membership: {
    id: string;
    organizationId: string;
    userId: string;
    role: 'auditor_readonly';
    expiresAt: string | null;
    createdAt: string;
  };
  user: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
  };
  /** Populated only in mock-auth dev mode. Real Stytch sends an email. */
  devToken: string | null;
}

export async function createAuditorSeat(body: CreateAuditorSeatRequest): Promise<CreateAuditorSeatResponse> {
  const res = await apiClient.post<{ data: CreateAuditorSeatResponse }>(
    '/api/compliance/auditor-seats',
    body,
  );
  return res.data.data;
}

export async function revokeAuditorSeat(membershipId: string, reasonForChange: string): Promise<void> {
  await apiClient.delete(`/api/compliance/auditor-seats/${encodeURIComponent(membershipId)}`, {
    data: { reasonForChange },
  });
}
